export default __webpack_public_path__ + "static/respect-f195b0cc20a54de0e63b3ff3adc0db38.png";